import { ProfileI18n } from '@/locales/base.message.locales';

export const profile: ProfileI18n = {
  titles: {
    about: 'About',
    about_you: '<h1><span>About</span> you</h1>',
    achievements: 'Achievements',
    activities: 'Activities',
    activities_register: '<h1><span>Activity</span> record</h1>',
    activities_description: 'This is where all your activities are recorded on the platform, for example when you started participating in a challenge or when it was completed.',
    bio: 'Bio',
    following: 'Following',
    following_challenges: '<h1><span>Challenges</span> followed</h1>',
    public_following_challenges: 'Challenges followed by',
    no_bio: 'So that other users can get to know you better, go to your profile settings and add a brief description about yourself. A good description can include information about your background or area of ​​expertise, interests, goals and why you are part of the IKONE platform.',
    public_no_bio: 'doesn\'t have a biography.',
    no_following: 'Now that you have participated in the IKONE platform you can follow challenges created by other users, to follow a challenge just go to the challenge screen, click on a challenge and just above the name there will be a button written "FOLLOW", just click and period ! Now the challenge followed will be saved here.',
    public_no_following: 'is not following any challenges.',
    no_challenge: 'Here you will see all the challenges created by you. To create a new challenge on the IKONE platform, go to the home screen in the "I have a challenge" section and enter the challenge information and your contact details, so a curator will be created to create your new challenge.',
    no_teams: 'In this section, all the teams created by you will be displayed. To create a team you must first be participating in a challenge. The option to create a team will be available just below the option to participate in the challenge.',
    public_no_teams: 'doesn\'t have any teams.',
    platform_settings: 'Platform Settings',
    profile: 'Profile',
    security: 'Security',
    change_password: 'Change Password',
    platform_notifications: 'Platform Notifications',
    change_email: 'Change e-mail',
    member_since: 'Member since',
    upload_picture: 'UPLOAD A PICTURE',
    view_team: 'See team',
    upload_progress: 'UPLOADING ...',
    my_challenges: '<h1><span>My</span> Challenges<h1>',
    my_challenges_tab: 'My Challenges',
    my_teams: '<h1><span>My</span> Teams</h1>',
    public_profile_teams: 'teams',
    date_format: 'Format: yyyy-mm-dd',
    no_skills: 'User has no registered skills.',
    visit_profile: 'Visit profile',
    membership_card: 'Membership card',
    certificates: 'Certificates',
    access_linkedin: 'Visit Linkedin',
    lives_helped: 'Helped over a million lives'
  },
  messages: {
    update_failed: 'Profile update has be failed',
    update_success: 'Profile update has be done',
    complete_your_profile: 'Please, complete your profile before',
    email_successfully_checked: 'Now you can participate in challenges, interact on forums and create teams. Let\'s change the world together?',
    complete_profile: 'Please, complete your profile!',
    no_achievements: 'No achievements'
  },
  platform_settings: {
    all_challenges: {
      new: 'New Challenges',
      title: 'All Challenges',
    },

    my_challenges: {
      forum: 'Forum',
      tasks: 'Tasks',
      title: 'My Challenges',
      update: 'Updates',
    },
    chat: {
      messages: 'Messages',
      title: 'Chat',
    },
    email: 'Email',
    email_frequency: {
      always: 'Always',
      title: 'Email Notification Frequency',
    },
    language: 'Language',
    platform: {
      check: 'Platform',
      ikone_notifications: 'Ikone Notifications',
      title: 'Platform',
    },
    timezone: 'Time Zone',
  },
};
